export default __webpack_public_path__ + "static/media/research-table-1.93435d01.png";